import { createSlice } from '@reduxjs/toolkit';
import {
  createBudget,
  fetchAllBudgets,
  fetchBudgetById,
  updateBudget,
  deleteBudget
} from './budgetsAction';
import { BudgetState } from './budgetsTypes';

const initialState: BudgetState = {
  budgets: [],
  selectedBudget: undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false,
  },
  errors: {}
};

const budgetsSlice = createSlice({
  name: 'budgets',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createBudget.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createBudget.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.budgets.push(action.payload.data);
      })
      .addCase(createBudget.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Fetch All
      .addCase(fetchAllBudgets.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllBudgets.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.budgets = action.payload.data;
      })
      .addCase(fetchAllBudgets.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchBudgetById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchBudgetById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedBudget = action.payload.data;
      })
      .addCase(fetchBudgetById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateBudget.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateBudget.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.budgets.findIndex(b => b.budget_id === action.payload.id);
        if (index !== -1) {
          state.budgets[index] = { ...action.payload.data, budget_id: action.payload.id };
        }
      })
      .addCase(updateBudget.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })

      // Delete
      .addCase(deleteBudget.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
      .addCase(deleteBudget.fulfilled, (state, action) => {
        state.loadingStates.delete = false;
        state.budgets = state.budgets.filter(b => b.budget_id !== action.payload);
      })
      .addCase(deleteBudget.rejected, (state, action) => {
        state.loadingStates.delete = false;
        state.errors.delete = action.payload as string;
      });
  }
});

export default budgetsSlice.reducer;
